import log from 'salvo-lite/log'
import 'slick-carousel'
import jQuery from 'jquery'
import AjaxAPI from '../helpers/AjaxAPI'

class Nosto {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem

        log.debug(this._name, 'Constructed', this)
    }

    async onInit () {
        var x = 0
        var options = {
            slidesToShow: 4,
            arrows: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        }

        // document.addEventListener('click', function (e) {
        //     const { target } = e
        //     const item = target.closest('.nosto-list-item')
        //     if (!item) return
        //     const parent = item.closest('.nosto_element')
        //     if (!parent) return

        //     const info = item.querySelector('.nosto-product-info')
        //     const placementId = parent.id
        //     const productId = info.id

        //     if (window.nostojs) {
        //         window.nostojs(function (api) {
        //             api.createRecommendationRequest()
        //                 .addEvent('vp', productId, placementId)
        //                 .loadRecommendations()
        //         })

        //         return true
        //     }
        // })

        var checkExist = setInterval(function () {
            if (jQuery('.nosto-list').length) {
                clearInterval(checkExist)

                jQuery('.nosto-list').each(function () {
                    jQuery(this).not('.slick-initialized').slick(options)
                })
            }

            if (++x === 5) {
                clearInterval(checkExist)
            }
        }, 1000)
    }

    static async createCartEvent () {
        const cart = await AjaxAPI.getCart()
        const items = cart.data.items.map(item => {
            return {
                product_id: item.product_id,
                sku_id: item.sku,
                name: item.title,
                unit_price: (item.final_price / 100).toFixed(2),
                quantity: item.quantity,
                price_currency_code: cart.data.currency
            }
        })

        Nosto.runNostoCart(items)
    }

    static runNostoCart (items) {
        if (window.nostojs) {
            // eslint-disable-next-line no-undef
            window.nostojs(api => api.resendCartContent({
                items
            }), api => {
                api.createRecommendationRequest()
                    .loadReccomendations()
            })

            return true
        }

        setTimeout(() => {
            Nosto.runNostoCart(items)
        }, 1000)
    }
}

export default Nosto



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Nosto.js